import * as Actions from './Actions'
import * as OverpanelActions from './overpanels'
import { post } from '../../calculator/lib/xhr'
import { ActionTypes as types } from '../constants'
import { fetchFundingOptions } from './send'
import { showUnifiedPreview } from '../../experiments/unified-preview'
import { fetchFundingOptions as fetchPayRequestFundingOptions } from './pay-request'
import { getFlowType } from '../utils/url-utils'

export function changeSelectedShippingAddress(id) {
  return {
    type: types.USER.CHANGE_SELECTED_SHIPPING_ADDRESS,
    data: { id },
  }
}

export function noSelectedShippingAddress() {
  return {
    type: types.USER.NO_SELECTED_SHIPPING_ADDRESS,
  }
}

export function changedShippingAddressCheckbox(checked) {
  return {
    type: types.USER.CHANGE_SHIPPING_ADDRESS_CHECKBOX,
    data: { checked },
  }
}

export function changeSelectedBillingAddress(id) {
  return {
    type: types.USER.CHANGE_SELECTED_BILLING_ADDRESS,
    data: { id },
  }
}

export function changeBillingAddressEntryField(field, value) {
  return {
    type: types.USER.CHANGE_BILLING_ADDRESS_ENTRY_FIELD,
    data: { field, value },
  }
}

export function changeShippingAddressEntryField(field, value) {
  return {
    type: types.USER.CHANGE_SHIPPING_ADDRESS_ENTRY_FIELD,
    data: { field, value },
  }
}

export function changeTravelRuleAddressEntryField(field, value) {
  return {
    type: types.USER.CHANGE_TRAVEL_RULE_ADDRESS_ENTRY_FIELD,
    data: { field, value },
  }
}

export function saveBillingAddress() {
  return (dispatch, getState) => {
    dispatch({ type: types.ADDRESS.ADD_ADDRESS })

    // grab necessary data out of the store
    const {
      address: { newBillingAddress },
      server: { country },
    } = getState()

    // massage data into the billingAddress object
    const billingAddress = {
      streetaddress1: newBillingAddress.line1,
      streetaddress2: newBillingAddress.line2,
      city: newBillingAddress.city,
      state: newBillingAddress.state,
      zipcode: newBillingAddress.postcode,
      country: country,
    }

    // we are sending the billingAddress payload up as shippingAddress since the
    // server does not distinguish between these two when adding an address
    post('/myaccount/transfer/address', { shippingAddress: billingAddress })
      .then((response = {}) => {
        const { addressBook = [] } = response
        let newlyAddedAddressId
        addressBook.forEach(address => {
          const { addressLine1: { value = '' } = {} } = address
          if (value === billingAddress.streetaddress1) {
            newlyAddedAddressId = address.id
          }
        })
        dispatch(
          savedBillingAddress({
            addresses: addressBook,
            id: newlyAddedAddressId,
          })
        )
        dispatch(
          OverpanelActions.toggleAddBillingAddressOverpanel({ show: false })
        )
      })
      .catch(Actions.handleError(dispatch))
  }
}

export function saveShippingAddress() {
  return (dispatch, getState) => {
    dispatch({ type: types.ADDRESS.ADD_ADDRESS })

    const {
      address: { newShippingAddress },
      server: {
        country,
        businessAccountInfo: { isDCSendMoneyRequest },
      },
      transaction: { preselectedFundingOption },
    } = getState()

    const shippingAddress = {
      streetaddress1: newShippingAddress.line1,
      streetaddress2: newShippingAddress.line2,
      city: newShippingAddress.city,
      state: newShippingAddress.state,
      zipcode: newShippingAddress.postcode,
      country: country,
    }

    post('/myaccount/transfer/address', { shippingAddress })
      .then((response = {}) => {
        const { addressBook = [] } = response
        let newlyAddedAddressId
        addressBook.forEach(address => {
          const { addressLine1: { value = '' } = {} } = address
          if (value === shippingAddress.streetaddress1) {
            newlyAddedAddressId = address.id
          }
        })
        dispatch(
          savedShippingAddress({
            addresses: addressBook,
            id: newlyAddedAddressId,
          })
        )
        dispatch(
          OverpanelActions.toggleAddShippingAddressOverpanel({ show: false })
        )

        if (!isDCSendMoneyRequest) {
          if (showUnifiedPreview()) {
            if (getFlowType() === 'payRequest') {
              dispatch(fetchPayRequestFundingOptions())
            } else {
              dispatch(fetchFundingOptions({ preselectedFundingOption }))
            }
          } else if (getFlowType() !== 'payRequest') {
            dispatch(fetchFundingOptions({ preselectedFundingOption }))
          }
        }
      })
      .catch(Actions.handleError(dispatch))
  }
}

export function savedShippingAddress({ addresses, id }) {
  return {
    type: types.ADDRESS.ADDED_SHIPPING_ADDRESS,
    data: { addresses, id },
  }
}

export function savedBillingAddress({ addresses, id }) {
  return {
    type: types.ADDRESS.ADDED_BILLING_ADDRESS,
    data: { addresses, id },
  }
}
